var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResize = function SvgResize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94C9B0",
    d: "M19.94 3.03a1.5 1.5 0 0 1 2.122 2.121l-16.91 16.91a1.5 1.5 0 0 1-2.122-2.12zM19.97 13.607a1.5 1.5 0 1 1 2.122 2.12l-6.364 6.365a1.5 1.5 0 1 1-2.121-2.121z"
  })));
};
export default SvgResize;